export enum SecondaryEICModificationStatus {
  PENDING = 'PEN',
  ACCEPTED = 'ACC'
}
